import Content from "./Content";
import './index.css';

const App = () => {

  return (
    <div className="main">
      <Content/>
    </div>
  )
}

export default App
